import MomentumLogo from '../../images/MomentumAMP Logo.png';
import '../../styles/pages.css';
import '../../styles/layout.css';

const FEATURES = [
  { icon: 'pi-file-edit', label: 'Certificates', desc: 'Issue and manage COIs instantly' },
  { icon: 'pi-send', label: 'Requests', desc: 'Track and fulfill holder requests' },
  { icon: 'pi-chart-bar', label: 'Reports', desc: 'Insights across policies and clients' },
];

export default function LoginPage() {
  const handleNowcertsClick = () => {
    const baseUrl = process.env.REACT_APP_Nowcerts_Url as string;
    const innerPath = 'Pages/InsuranceGIG/RedirectToIG.aspx';
    const innerParams = new URLSearchParams({
      igorigin: 'nccoi',
      agencyId: '2aa29171-0d21-4641-a774-7fac291a1cc2',
      showAgencyLogo: 'true',
    });
    const internalReturnUrl = `${innerPath}?${innerParams.toString()}`;
    const finalUrl = `${baseUrl}?InternalReturnUrl=${encodeURIComponent(internalReturnUrl)}`;
    if (window.innerWidth > 767) {
      window.location.href = finalUrl;
    } else {
      window.open(finalUrl, '_blank');
    }
  };

  return (
    <div className="loginShell">
      {/* Left branding panel */}
      <div className="loginShell__left">
        <div className="loginShell__leftInner">
          <div className="loginShell__leftLogo">
            <img src={MomentumLogo} alt="Momentum AMP" className="loginShell__leftLogoImg" />
          </div>
          <div className="loginShell__leftTagline">Certificate of Insurance Portal</div>
          <p className="loginShell__leftSub">
            Your one-stop portal for managing certificates of insurance, requests, and compliance documents.
          </p>
          <div className="loginShell__features">
            {FEATURES.map((f) => (
              <div key={f.icon} className="loginShell__featureRow">
                <div className="loginShell__featureIcon">
                  <i className={`pi ${f.icon}`} />
                </div>
                <div>
                  <div className="loginShell__featureLabel">{f.label}</div>
                  <div className="loginShell__featureDesc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* decorative blobs */}
        <div className="loginShell__blob loginShell__blob--1" />
        <div className="loginShell__blob loginShell__blob--2" />
      </div>

      {/* Right auth panel */}
      <div className="loginShell__right">
        <div className="loginShell__panel">
          <div className="loginShell__mobileLogoWrap">
            <img src={MomentumLogo} alt="Momentum AMP" className="loginShell__mobileLogo" />
          </div>

          <div className="loginShell__cardLogo">
            <img src={MomentumLogo} alt="Momentum AMP" className="loginShell__cardLogoImg" />
          </div>

          <div className="loginShell__headline">Sign in to continue</div>
          <p className="loginShell__subtext">
            Use your NowCerts account to access your agency workspace.
          </p>

          <div className="loginShell__actions">
            <button
              type="button"
              className="loginShell__primaryBtn"
              onClick={handleNowcertsClick}
            >
              <i className="pi pi-sign-in" />
              Continue with NowCerts
            </button>
          </div>

          <div className="loginShell__secureRow">
            <i className="pi pi-shield-check loginShell__secureIcon" />
            <span className="loginShell__hint">Secure single sign-on — no separate password needed.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
